import { render, staticRenderFns } from "./GoogleLoginButtonRedirection.vue?vue&type=template&id=2bd297a2"
import script from "./GoogleLoginButtonRedirection.vue?vue&type=script&lang=js"
export * from "./GoogleLoginButtonRedirection.vue?vue&type=script&lang=js"
import style0 from "./GoogleLoginButtonRedirection.vue?vue&type=style&index=0&id=2bd297a2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports